import Handlebars from 'handlebars/dist/cjs/handlebars';
import PerfectScrollbar from 'perfect-scrollbar';
import axios from 'axios';

import { API_PATH } from '../../constants';
import Modal from '../../components/modal/index';

(() => {
    const selectors = {
        hbsSourceDesc   : 'hbs-template__js-desc',
        hbsTemplateDesc : 'hbs-template-desc',
        scrollDesc      : 'clip-scroll',
        modal           : '#modal-slideshow',
        wrapperImg      : '.article-list__picture'
    };

    const cssClasses = {
        isLoading: 'is-loading'
    };

    const videoDesc    = { info: {} };
    const sourceDesc   = document.getElementById(selectors.hbsSourceDesc).innerHTML;
    const templateDesc = Handlebars.compile(sourceDesc);

    function openVideo(id, data) {
        const modal = new Modal(selectors.modal, false);
        
        videoDesc.info = {
            title       : data[0].title,
            description : data[0].description
        };

        modal.openModal();

        if (player) player.loadVideoById(id);
        document.getElementById(selectors.hbsTemplateDesc).innerHTML = templateDesc(videoDesc);
        addScroll();
    }

    function addScroll() {
        let titleHeight = document.getElementById('clip-title').offsetHeight;

        if (window.innerWidth > 768) {
            document.getElementById(selectors.scrollDesc).style.height = `${ 460 - (titleHeight + 30)}px`;
            new PerfectScrollbar(document.getElementById(selectors.scrollDesc), { suppressScrollX: true });
        } else {
            document.getElementById(selectors.scrollDesc).style.height = `${ window.innerHeight - (titleHeight + 70)}px`;
        }
    };

    Array.prototype.slice
        .call(document.querySelectorAll(".article-list__link[data-type='video']"))
            .map((item) => {
                item.addEventListener('click', (evt) => {
                    evt.preventDefault();

                    const loading = evt.currentTarget.querySelector(selectors.wrapperImg);
                    const ID      = item.getAttribute('data-tip-id');
                    const vID     = item.getAttribute('data-video-id').split('v=')[1];

                    loading.classList.add(cssClasses.isLoading);
   
                    axios.get(`${API_PATH}/tips`, { params: { ids: ID } })
                        .then((response) => {
                            if (response.data.success) {
                                const data = response.data.data;
                                loading.classList.remove(cssClasses.isLoading);
                                openVideo(vID, data);
                            } else {
                                loading.classList.remove(cssClasses.isLoading);
                                console.log('GET Error TIP ID ->', response.data.message);
                            }
                        })
                        .catch((error) => {
                            loading.classList.remove(cssClasses.isLoading);
                            console.warn('GET Error TIP ID', error);
                        });
                });
            });
})();
